<template>
  <div class="label-desc">
    <p>{{ label }}</p>
    <p><b v-if="negrito"><span>{{ descricao }}</span></b> <span v-if="!negrito">{{ descricao }}</span></p>
  </div>
</template>
<script>
export default {
  name: 'LabelDesc',
  props: {
    label: {
      required: true,
      type: String
    },
    descricao: {
      required: true,
      type: String
    },
    negrito: {
      type: Boolean
    }
  }
}
</script>
